// mutates arguments, but whatever...
// each "reducer" receives composebody controller scope
// and content element comments by index

/* global $ */

import { commentFactory } from '~/modules/contentComment/contentComment.controller'
// import { getForceHeight } from '~/modules/contentElement/directive'

// Eric - This Really should not be here, but I need to get in a hotfix....
// We need to rethink this whole comments thing.
let _ts
function bounceLoad() {
  if (_ts) {
    window.clearTimeout(_ts)
  }
  _ts = window.setTimeout(
    () => storyControllerReducers.COMMENT_REPOSITION(),
    500
  )
}

document.body.addEventListener(
  'load',
  (event) => {
    var target = event.target
    if (['IMG', 'IFRAME'].indexOf(target.tagName) > -1) {
      bounceLoad()
    }
  },
  true
)

export const storyControllerReducers = {
  // action comes from contentTools.controller
  COMMENT_FOCUS: ({ storyCtrl, action }) => {
    storyCtrl.focusedComment = action.index
  },
  OPEN_COMMENT: ({ storyCtrl, action }) => {
    var _id = action.elements[action.index].additional_properties._id
    function check() {
      var target = $(`content-comment[data-comment-id="${_id}"]:visible`)
      if (target.length) {
        storyControllerReducers.COMMENT_REPOSITION()
      } else {
        setTimeout(check, 10)
      }
    }
    check()
  },
  ORIGIN_COMMENT_DESTROY: function({ storyCtrl, storyService, _id, action }) {
    if (action.element) {
      storyCtrl.story.content_elements[
        action.index
      ].additional_properties.comments = []
      storyService.save()
    }
  },

  COMMENT_REPOSITION: function(retryAttempt, cnt = 0) {
    const collection = retryAttempt || $(`content-comment[data-comment-id]`)
    collection.each((i, comElem) => {
      const jComElem = $(comElem)
      const _id = jComElem.attr('data-comment-id')
      const contElem = $(`[content-element][data-comment-id='${_id}']`)
      const pos = contElem.position()
      if (pos) {
        jComElem.css('top', pos.top + 'px')
      } else {
        if (cnt < 20) {
          window.setTimeout(
            () => storyControllerReducers.COMMENT_REPOSITION(jComElem, cnt++),
            100
          )
        }
      }
    })
  },
}

export const composeBodyReducers = {
  CANCEL_ORIGIN_COMMENT: ({ composeBodyScope, action, comments }) => {
    composeBodyScope.focusedComment = -1
    comments[0].text = ''
  },
  ORIGIN_COMMENT_CANCEL: ({ composeBodyScope, action, comments }) => {
    composeBodyScope.focusedComment = -1
  },
  ORIGIN_COMMENT_SAVE: ({
    composeBodyScope,
    storyService,
    action,
    comments,
  }) => {
    comments[0] = {
      ...comments[0],
      ...action.payload,
    }
    storyService.save()
  },
  ORIGIN_COMMENT_EDIT: ({
    composeBodyScope,
    storyService,
    action,
    comments,
  }) => {
    composeBodyScope.focusedComment = action.index
  },
  ORIGIN_COMMENT_DESTROY: ({
    composeBodyScope,
    storyService,
    action,
    comments,
  }) => {
    if (action.element) {
      composeBodyScope.focusedComment = -1
    }
  },
  ORIGIN_REPLY_ACCEPT: ({
    composeBodyScope,
    storyService,
    action,
    comments,
  }) => {
    storyService.save()
  },
}

export const commentPopoverReducers = {
  ORIGIN_COMMENT_EDIT: function({ action }) {},
  ORIGIN_REPLY_ADD_INIT: function({ action }) {
    if (this._id === action._id && this.replyIndex === action.replyIndex) {
      this.ui = false
    }
  },
  ORIGIN_REPLY_EDIT_CANCEL: function({ action }) {
    if (this._id === action._id && this.replyIndex === action.replyIndex) {
      this.ui = false
    }
  },
  ORIGIN_REPLY_EDIT: function({ action }) {
    if (this._id === action._id && this.replyIndex === action.replyIndex) {
      this.ui = false
    }
  },
  ORIGIN_REPLY_EDIT_SAVE: function({ action }) {
    if (this._id === action._id && this.replyIndex === action.replyIndex) {
      this.ui = false
    }
  },
}

// cannot use fat arrow for these since scope is tied to this
export const contentCommentReducers = {
  OPEN_COMMENT: function({ action }) {
    // if no comment, give it one and focus for input
    const elem = action.elements[action.index]
    if (
      this._id === elem.additional_properties._id &&
      this.comments.length < 1
    ) {
      const blankComment = commentFactory()
      this.comments.push(blankComment)
      this.editingOrigin = true
      if (typeof action.callback === 'function') {
        action.callback()
      }
    }
  },
  COMMENT_FOCUS: function({ action }) {
    if (action._id === this._id) {
      this.focusedComment = action.index
    } else {
      this.focusedComment = -1
    }
  },
  ORIGIN_COMMENT_DESTROY: function({ action }) {
    if (action._id !== this._id) {
      this.models.origin = ''
      this.editingOrigin = false
    }
  },
  ORIGIN_COMMENT_CANCEL: function({ action }) {
    if (action._id !== this._id) {
      return
    }
    // if canceling from first comment
    if (this.isOrigin === true) {
      this.comments = []
    }
    this.editingOrigin = false
    this.models.origin = ''
  },
  ORIGIN_COMMENT_EDIT: function({ action }) {
    if (action._id === this._id) {
      this.editingOrigin = true
      this.models.origin = action.comment.text
    }
  },
  ORIGIN_COMMENT_SAVE: function({ toastr, action }) {
    if (action._id === this._id) {
      this.editingOrigin = false
      // no longer is "first" origin, now a comment exists
      if (this.isOrigin === true) {
        this.isOrigin = false
      }
    }
  },
  ORIGIN_REPLY_CANCEL: function({ action }) {
    if (action._id === this._id) {
      this.models.reply = ''
      this.isReplying = false
    }
  },
  ORIGIN_REPLY_ACCEPT: function({ action }) {
    if (action._id !== this._id) {
      return
    }
    // clear the input text box
    this.models.reply = ''
    // hides the input text box
    this.isReplying = false
    if (this.comments[0]) {
      if (this.comments[0].replies) {
        this.comments[0].replies.push(action.payload)
        this.models.replies.push({ ui: false, cache: ' ' })
      } else {
        this.comments[0].replies = [action.payload]
        this.models.replies = [{ ui: false, cache: ' ' }]
      }
      // adding comment always expands replies
      this.repliesExpanded = true
    }
  },
  ORIGIN_REPLY_EDIT: function({ action }) {
    if (action._id === this._id) {
      this.models.replies[action.replyIndex].ui = true
      this.models.replies[action.replyIndex].cache = this.comments[0].replies[
        action.replyIndex
      ].text
    }
  },
  ORIGIN_REPLY_EDIT_CANCEL: function({ action }) {
    if (action._id === this._id) {
      this.models.replies[action.replyIndex].ui = false
      this.models.replies[action.replyIndex].cache = ' '
    }
  },
  ORIGIN_REPLY_EDIT_SAVE: function({ action }) {
    if (action._id === this._id) {
      this.models.replies[action.replyIndex].ui = false
      this.comments[0].replies[action.replyIndex].text = this.models.replies[
        action.replyIndex
      ].cache
      action.storyService.save()
    }
  },
  ORIGIN_REPLY_DESTROY: function({ action }) {
    if (action._id === this._id) {
      this.models.replies.splice(action.replyIndex, 1)
      this.comments[0].replies.splice(action.replyIndex, 1)
      action.storyService.save()
    }
  },
  ORIGIN_REPLY_ADD_INIT: function({ action }) {
    if (this._id === action._id) {
      this.isReplying = action.payload.isReplying
    }
  },
  ORIGIN_TOGGLE_REPLIES_VISIBILITY: function({ action }) {
    if (this._id === action._id) {
      this.repliesExpanded = !this.repliesExpanded
    }
  },
}
